import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { UserLogan, UserLoganAirports } from 'src/app/core/models/userLogan';
import { AuthService } from 'src/app/core/services/auth.service';
import { MenuItem } from 'src/app/layouts/sidebar/menu.model';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { MENU } from './../../layouts/sidebar/menu';
import { VanTransferLocal } from 'src/app/core/models/vanTransfer.model';
import { VanTransferService } from 'src/app/core/services/vanTransfer.service';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PermissionType } from './permissions/permission-type.enum';
import {
  Permission,
  PermissionItems,
  PermissionScreens,
} from './permissions/models/permission.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { NewUser } from 'src/app/core/models/persons.model';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit {
  users: UserLogan[] = [];
  newUser: NewUser = new NewUser();
  newUserForm: any;
  resetPasswordUserId: number = -1;
  emailAvaliableForm: any;
  emailVerified: boolean = false;
  userLoganAirports: UserLoganAirports = new UserLoganAirports();
  userLoganAirportsSelect = [];
  menu: string[] = ['Admin', 'Todos'];
  circularProgressiveWait = true;
  vanTransferLocal: VanTransferLocal[] = [];
  permissionsForm: any;
  userEditPermissions: any;
  userEditId: any;
  permissionsScreen: PermissionScreens = new PermissionScreens(environment);
  dialog: any;
  constructor(
    private fb: FormBuilder,
    private vanTransferService: VanTransferService,
    private authService: AuthService,
    public toastService: ToastService,
    private modalService: NgbModal
  ) {
    this.userLoganAirports.airports = '';
    this.userLoganAirports.filterMovidaTransfer = false;
    MENU.forEach((item: any) => {
      var hasSubItem = this.hasItems(item);
      if (hasSubItem) {
        item.subItems.forEach((subItem: any) => {
          this.menu.push(item.label + ' - ' + subItem.label);
        });
      } else {
        this.menu.push(item.label);
      }
    });
    this.emailAvaliableForm = new FormGroup({
      email: new FormControl(undefined, [
        Validators.email,
        Validators.required,
      ]),
    });
  }
  createNewUser() {
    this.circularProgressiveWait = true;
    this.authService.createNewUser(this.newUser.fromForm).subscribe({
      complete: () => {
        this.toastService.show('Usuário criado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.dialog.close();
        this.init();
      },
      error: (err: any) => {
        this.circularProgressiveWait = false;
        this.toastService.show('Erro ao criar usuário - ' + err, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      },
    });
  }
  emailAvalibleVerify() {
    this.circularProgressiveWait = true;
    this.newUser = new NewUser();
    this.authService
      .emailAvaliableCheck(this.emailAvaliableForm.get('email').value)
      .subscribe({
        next: (response: any) => {
          let map = Object(response);
          if (map != undefined && map['data'].length > 0) {
            this.newUser.asForm
              .get('userId')!
              .setValue(map['data'][0]['user']['id']);
            this.newUser.asForm
              .get('name')!
              .setValue(map['data'][0]['user']['name']);
            this.newUser.asForm
              .get('username')!
              .setValue(map['data'][0]['user']['username']);
            this.newUser.asForm
              .get('email')!
              .setValue(map['data'][0]['user']['email']);
          } else {
            this.newUser.asForm
              .get('email')
              ?.setValue(this.emailAvaliableForm.get('email').value);
          }
          this.emailVerified = true;
          this.circularProgressiveWait = false;
        },
        error: (err: any) => {
          this.circularProgressiveWait = false;
          this.toastService.show('Erro ao verificar email - ' + err.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        },
      });
  }
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  getAirportName(id: any) {
    let index = this.vanTransferLocal.findIndex((item: VanTransferLocal) => {
      return item.id == id;
    });
    if (index > -1) {
      return this.vanTransferLocal[index].name;
    } else {
      return '';
    }
  }

  getAirport(id: any) {
    let index = this.vanTransferLocal.findIndex((item: VanTransferLocal) => {
      return item.id == id;
    });
    if (index > -1) {
      return this.vanTransferLocal[index];
    } else {
      return '';
    }
  }

  getAirportId(name: any) {
    let index = this.vanTransferLocal.findIndex((item: VanTransferLocal) => {
      return item.name == name;
    });
    if (index > -1) {
      return this.vanTransferLocal[index].id;
    } else {
      return -1;
    }
  }

  prepareScreensSelect(item: string[]) {
    var nameScreen: string[] = [];
    item.forEach((itemFor: any) => {
      if (itemFor == '*') {
        nameScreen.push('Todos');
      } else if (itemFor == '**') {
        nameScreen.push('Admin');
      }
      MENU.forEach((itemMenu: MenuItem) => {
        var hasSubItem = this.hasItems(itemMenu);
        if (hasSubItem) {
          itemMenu.subItems.forEach((subItem: any) => {
            if (subItem.id == itemFor) {
              nameScreen.push(itemMenu.label + ' - ' + subItem.label);
            }
          });
        } else {
          if (itemFor == itemMenu.id) {
            nameScreen.push(itemMenu.label);
          }
        }
      });
    });
    return nameScreen;
  }
  openModal(centerDataModal: any, user?: any) {
    if (user) {
      this.userEditId = user.id;
      this.userEditPermissions = [...user.permissions];
      this.setPermissions(this.userEditPermissions);
    }
    this.dialog = this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  save(user: UserLogan) {
    var screenListAux: string[] = [];
    user.screensList.forEach((itemFor: any) => {
      if (itemFor == 'Todos') {
        screenListAux.push('*');
      } else if (itemFor == 'Admin') {
        screenListAux.push('**');
      } else {
        MENU.forEach((itemMenu: MenuItem) => {
          var hasSubItem = this.hasItems(itemMenu);
          if (hasSubItem) {
            itemMenu.subItems.forEach((subItem: any) => {
              if (itemMenu.label + ' - ' + subItem.label == itemFor) {
                screenListAux.push(String(itemMenu.id));
                screenListAux.push(String(subItem.id));
              }
            });
          } else {
            if (itemFor == itemMenu.label) {
              screenListAux.push(String(itemMenu.id));
            }
          }
        });
      }
    });

    user.screens = screenListAux
      .filter((n: any, i: any) => screenListAux.indexOf(n) === i)
      .join(',');
    user.airports = '';
    if (user.filterMovidaTransfer) {
      user.airportsList.forEach((aux: any) => {
        if (user.airports != '') {
          user.airports = user.airports + ',';
        }
        user.airports = user.airports + String(aux);
      });
    }
    this.circularProgressiveWait = true;
    this.authService.updateUserScreens(user).subscribe(
      (response: any) => {
        this.toastService.show('Atualizado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.init();
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao atualizar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
      }
    );
  }

  getLocals() {
    this.vanTransferLocal = [];
    this.vanTransferService
      .selectVanTransferLocal(this.userLoganAirports)
      .subscribe((response: any) => {
        if (response != null) {
          this.vanTransferLocal = response;
        }
      });
  }

  init() {
    this.getLocals();
    this.authService.getAllUserScreens().subscribe(
      (response: UserLogan[]) => {
        this.users = response;
        this.users.forEach((item: UserLogan) => {
          item.screensList = item.screens?.split(',');
          if (item.screensList != undefined && item.screensList.length > 0) {
            item.screensList = this.prepareScreensSelect(item.screensList);
          }
          if (
            item.airports != null &&
            item.airports != undefined &&
            item.airports != ''
          ) {
            item.airportsList = (item.airports + ',').split(',');
            let aux: any[] = [];
            item.airportsList.forEach((airportId: any) => {
              if (airportId != '') {
                aux.push(Number(airportId));
              }
            });
            item.airportsList = aux;
          }
        });
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao carregar página - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
      }
    );
  }
  ngOnInit(): void {
    this.permissionsForm = this.fb.group({
      permissions: this.fb.array([]),
    });
    this.init();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userEditPermissions && this.userEditPermissions) {
      this.setPermissions(this.userEditPermissions);
    }
  }
  setPermissions2(permissionsData: any) {
    permissionsData.map((screenData: any) => {
      const items = screenData.items.map((item: any) => {
        return new PermissionItems(item.item, item.values);
      });
      return new Permission(screenData.screen, items);
    });
  }
  setPermissions(permissionsData: any) {
    const permissionsArray = this.permissionsForm.get(
      'permissions'
    ) as FormArray;
    permissionsArray.clear();

    permissionsData.map((screenData: any) => {
      const items = screenData.items.map((item: any) => {
        return new PermissionItems(item.item, item.values);
      });
      return new Permission(screenData.screen, items);
    });
  }

  get permissions() {
    return this.permissionsForm.get('permissions') as FormArray;
  }

  getItemsArray(index: number): FormArray {
    return this.permissions.at(index).get('items') as FormArray;
  }

  anyValueTrue(item: any) {
    let keys = Object.keys(item.permissions);
    for (let index = 0; index < keys.length; index++) {
      const element = item.permissions[keys[index]];
      if (element) {
        return true;
      }
    }
    return false;
  }
  getScreenIndex(screen: string) {
    return this.permissionsScreen.screens.findIndex((item: any) => {
      return item.screen == screen;
    });
  }

  getDescriptionItem(screen: string, itemName: string) {
    let screenIndex = this.getScreenIndex(screen);
    if (screenIndex > -1) {
      let itemIndex = this.permissionsScreen.screens[
        screenIndex
      ].items.findIndex((item: any) => {
        return item.item == itemName;
      });
      if (itemIndex > -1) {
        return Object(
          this.permissionsScreen.screens[screenIndex].items[itemIndex]
        ).description;
      }
    }
    return null;
  }

  getDescriptionScreen(screen: string) {
    let screenIndex = this.getScreenIndex(screen);
    if (screenIndex > -1) {
      return this.permissionsScreen.screens[screenIndex].description;
    }
    return null;
  }
  openModalPasswordConfirm(centerDataModal: any, userId: number) {
    this.resetPasswordUserId = userId;
    this.dialog = this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  resetPassword() {
    if (this.resetPasswordUserId > -1) {
      this.circularProgressiveWait = true;
      this.authService.resetPassword(this.resetPasswordUserId).subscribe({
        next: (response: any) => {
          if (response == '"{"result":true}"') {
            this.toastService.show('Email com a senha enviado com sucesso', {
              classname: 'bg-success text-center text-white',
              delay: 2500,
            });
          } else {
            this.toastService.show('Erro ao solicitar reset de senha', {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            });
          }

          this.circularProgressiveWait = false;
          this.dialog.close();
        },
        error: (error: any) => {
          this.toastService.show(
            'Erro ao solicitar reset de senha - ' + error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
          this.circularProgressiveWait = false;
        },
      });
    }
  }
  savePermissions() {
    this.circularProgressiveWait = true;
    this.authService
      .updatePermissions(this.userEditPermissions, this.userEditId)
      .subscribe({
        complete: () => {
          this.toastService.show('Permissões atualizdas com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.circularProgressiveWait = false;
          this.dialog.close();
        },
        error: (error: any) => {
          this.toastService.show('Erro ao atualizar permissões', {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        },
      });
  }

  getPermissionKeys(): string[] {
    return Object.keys(PermissionType);
  }

  getObjectKeys(item: any) {
    return Object.keys(item);
  }
  getValueObjectByKey(item: any, key: string) {
    return Object(item)[key];
  }
  getValueObjectByKeyAndSubkey(item: any, key: string, subkey: string) {
    return Object(item)[key][subkey];
  }

  getPermissionValue(screen: string, screenItem: string, key: string) {
    let indexScreen = this.userEditPermissions.findIndex((item: any) => {
      return item.screen == screen;
    });
    if (indexScreen > -1) {
      let indexScreenItem = this.userEditPermissions[indexScreen][
        'items'
      ].findIndex((item: any) => {
        return item.item == screenItem;
      });
      if (indexScreenItem > -1) {
        return this.userEditPermissions[indexScreen]['items'][indexScreenItem]
          .permissions[key];
      }
    }
    return false;
  }

  togglePermission(
    screen: string,
    screenItem: string,
    key: string,
    id: number
  ) {
    let screenEntry = this.userEditPermissions.find(
      (item: any) => item.screen === screen
    );

    if (!screenEntry) {
      screenEntry = {
        screen: screen,
        description: '',
        items: [],
      };
      this.userEditPermissions.push(screenEntry);
    }
    let itemEntry = screenEntry.items.find(
      (item: any) => item.item === screenItem
    );

    if (!itemEntry) {
      itemEntry = {
        id: id,
        item: screenItem,
        permissions: {},
      };
      screenEntry.items.push(itemEntry);
    }
    itemEntry.permissions[key] = !itemEntry.permissions[key];
  }
}
